export default "__VITE_ASSET__DCPAtodz__"